"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackException = exports.trackEvent = exports.setData = exports.getGoogleAnalytics = exports.getAllGoogleAnalytics = exports.disableForThisPage = exports.anonymizeIps = void 0;
const browser_rum_1 = require("@datadog/browser-rum");
const env_1 = require("../env");
// Didn't export this on purpose, so no one tries to use it to do something wacky.
const getAllGoogleAnalytics = () => {
  var _window, _window2, _window2$ga, _window2$ga$getAll;
  if ((0, env_1.isServer)() || !window || !((_window = window) !== null && _window !== void 0 && _window.ga)) return null;
  const trackers = (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$ga = _window2.ga) === null || _window2$ga === void 0 ? void 0 : (_window2$ga$getAll = _window2$ga.getAll) === null || _window2$ga$getAll === void 0 ? void 0 : _window2$ga$getAll.call(_window2$ga);
  if (!trackers || !trackers.length) return null;
  return trackers;
};
exports.getAllGoogleAnalytics = getAllGoogleAnalytics;
// Didn't export this on purpose, so no one tries to use it to do something wacky.
const getGoogleAnalytics = () => {
  const trackers = getAllGoogleAnalytics();
  return trackers ? trackers[0] : null;
};
exports.getGoogleAnalytics = getGoogleAnalytics;
// Page View is not implemented here because our system automatically tracks Page Views.
// You really shouldn't be doing that manually.
const setData = (key, value) => {
  const ga = getGoogleAnalytics();
  if (!ga) return;
  ga.send('set', key, value);
  browser_rum_1.datadogRum.addRumGlobalContext(`data_${key}`, value);
};
exports.setData = setData;
const anonymizeIps = () => setData('anonymizeIp', true);
exports.anonymizeIps = anonymizeIps;
const trackEvent = function (eventCategory, eventAction) {
  let eventLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
  let eventValue = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
  let nonInteraction = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  const ga = getGoogleAnalytics();
  if (!ga) return;
  ga.send('event', {
    eventCategory,
    eventAction,
    eventLabel,
    eventValue,
    transport: 'beacon',
    nonInteraction
  });
  browser_rum_1.datadogRum.addAction(eventCategory, {
    eventAction,
    eventLabel,
    eventValue,
    nonInteraction
  });
};
exports.trackEvent = trackEvent;
const trackException = function (exception) {
  let fatal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  const ga = getGoogleAnalytics();
  if (!ga) return;
  if (!exception || !exception.message) return;
  ga.send('exception', {
    exDescription: exception.message,
    exFatal: fatal
  });
};
exports.trackException = trackException;
const disableForThisPage = function () {
  let accountId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  if (process.env.BUILD_TARGET === 'server') return true;
  if (accountId) {
    window[`ga-disable-${accountId}`] = true;
    return true;
  }
  const trackers = getAllGoogleAnalytics();
  if (trackers && trackers.length) {
    trackers.forEach(tracker => {
      window[`ga-disable-${tracker.get('trackingId')}`] = true;
    });
    return true;
  }
  return false;
};
exports.disableForThisPage = disableForThisPage;